module.exports = {
        srcSet: __webpack_public_path__ + "e1de4d8f576c8305-600.webp"+" 600w"+","+__webpack_public_path__ + "8b3cc8179086856e-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "e1de4d8f576c8305-600.webp",width: 600,height: 378},{path: __webpack_public_path__ + "8b3cc8179086856e-1000.webp",width: 1000,height: 631}],
        src: __webpack_public_path__ + "8b3cc8179086856e-1000.webp",
        toString: function(){return __webpack_public_path__ + "8b3cc8179086856e-1000.webp"},
        
        width: 1000,
        height: 631
      }